(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('util'), require('react'), require('prop-types')) :
	typeof define === 'function' && define.amd ? define(['util', 'react', 'prop-types'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['ui-predicate-react'] = factory(global.require$$0, global.React, global.PropTypes));
}(this, (function (require$$0, React, PropTypes) {
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function commonjsRequire (path) {
		throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
	}

	var src$1 = {exports: {}};

	var isArrayish$1 = function isArrayish(obj) {
		if (!obj) {
			return false;
		}

		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && obj.splice instanceof Function);
	};

	var util = require$$0__default['default'];
	var isArrayish = isArrayish$1;

	var errorEx$1 = function errorEx(name, properties) {
		if (!name || name.constructor !== String) {
			properties = name || {};
			name = Error.name;
		}

		var errorExError = function ErrorEXError(message) {
			if (!this) {
				return new ErrorEXError(message);
			}

			message = message instanceof Error
				? message.message
				: (message || this.message);

			Error.call(this, message);
			Error.captureStackTrace(this, errorExError);

			this.name = name;

			Object.defineProperty(this, 'message', {
				configurable: true,
				enumerable: false,
				get: function () {
					var newMessage = message.split(/\r?\n/g);

					for (var key in properties) {
						if (!properties.hasOwnProperty(key)) {
							continue;
						}

						var modifier = properties[key];

						if ('message' in modifier) {
							newMessage = modifier.message(this[key], newMessage) || newMessage;
							if (!isArrayish(newMessage)) {
								newMessage = [newMessage];
							}
						}
					}

					return newMessage.join('\n');
				},
				set: function (v) {
					message = v;
				}
			});

			var overwrittenStack = null;

			var stackDescriptor = Object.getOwnPropertyDescriptor(this, 'stack');
			var stackGetter = stackDescriptor.get;
			var stackValue = stackDescriptor.value;
			delete stackDescriptor.value;
			delete stackDescriptor.writable;

			stackDescriptor.set = function (newstack) {
				overwrittenStack = newstack;
			};

			stackDescriptor.get = function () {
				var stack = (overwrittenStack || ((stackGetter)
					? stackGetter.call(this)
					: stackValue)).split(/\r?\n+/g);

				// starting in Node 7, the stack builder caches the message.
				// just replace it.
				if (!overwrittenStack) {
					stack[0] = this.name + ': ' + this.message;
				}

				var lineCount = 1;
				for (var key in properties) {
					if (!properties.hasOwnProperty(key)) {
						continue;
					}

					var modifier = properties[key];

					if ('line' in modifier) {
						var line = modifier.line(this[key]);
						if (line) {
							stack.splice(lineCount++, 0, '    ' + line);
						}
					}

					if ('stack' in modifier) {
						modifier.stack(this[key], stack);
					}
				}

				return stack.join('\n');
			};

			Object.defineProperty(this, 'stack', stackDescriptor);
		};

		if (Object.setPrototypeOf) {
			Object.setPrototypeOf(errorExError.prototype, Error.prototype);
			Object.setPrototypeOf(errorExError, Error);
		} else {
			util.inherits(errorExError, Error);
		}

		return errorExError;
	};

	errorEx$1.append = function (str, def) {
		return {
			message: function (v, message) {
				v = v || def;

				if (v) {
					message[0] += ' ' + str.replace('%s', v.toString());
				}

				return message;
			}
		};
	};

	errorEx$1.line = function (str, def) {
		return {
			line: function (v) {
				v = v || def;

				if (v) {
					return str.replace('%s', v.toString());
				}

				return null;
			}
		};
	};

	var errorEx_1 = errorEx$1;

	var errorEx = errorEx_1;

	var errors = {
	  InitialisationFailed: errorEx('InitialisationFailed')
	};

	var UIPredicateContext = /*#__PURE__*/React.createContext(null);

	function useUIPredicateContext() {
	  var context = React.useContext(UIPredicateContext);

	  if (!context) {
	    throw new Error("The component needs to be wrapped in the `UIPredicate` component.");
	  }

	  return context;
	}

	function UIPredicateOptions(_ref) {
	  var predicate = _ref.predicate;

	  var _useUIPredicateContex = useUIPredicateContext(),
	      add = _useUIPredicateContex.add,
	      remove = _useUIPredicateContex.remove,
	      isInAddCompoundMode = _useUIPredicateContex.isInAddCompoundMode,
	      UITypes = _useUIPredicateContex.UITypes,
	      getUIComponent = _useUIPredicateContex.getUIComponent;

	  var AddComponent = getUIComponent(UITypes.PREDICATE_ADD);
	  var RemoveComponent = getUIComponent(UITypes.PREDICATE_REMOVE);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__options"
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__option"
	  }, /*#__PURE__*/React__default['default'].createElement(RemoveComponent, {
	    onClick: function onClick() {
	      return remove(predicate);
	    },
	    predicate: predicate,
	    isInAddCompoundMode: isInAddCompoundMode,
	    disabled: !predicate.$canBeRemoved
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__option"
	  }, /*#__PURE__*/React__default['default'].createElement(AddComponent, {
	    predicate: predicate,
	    isInAddCompoundMode: isInAddCompoundMode,
	    onClick: function onClick() {
	      return add(predicate);
	    }
	  })));
	}
	UIPredicateOptions.propTypes = {
	  predicate: PropTypes__default['default'].object
	};

	function UIPredicateComparison(_ref) {
	  var predicate = _ref.predicate,
	      columns = _ref.columns;

	  var _useUIPredicateContex = useUIPredicateContext(),
	      setPredicateTarget_id = _useUIPredicateContex.setPredicateTarget_id,
	      setPredicateOperator_id = _useUIPredicateContex.setPredicateOperator_id,
	      UITypes = _useUIPredicateContex.UITypes,
	      getUIComponent = _useUIPredicateContex.getUIComponent;

	  var TargetsComponent = getUIComponent(UITypes.TARGETS);
	  var OperatorsComponent = getUIComponent(UITypes.OPERATORS);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__row ui-predicate__row--comparison"
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, /*#__PURE__*/React__default['default'].createElement(TargetsComponent, {
	    columns: columns,
	    predicate: predicate,
	    onChange: function onChange(target_id) {
	      return setPredicateTarget_id(predicate, target_id);
	    }
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, /*#__PURE__*/React__default['default'].createElement(OperatorsComponent, {
	    columns: columns,
	    predicate: predicate,
	    onChange: function onChange(operator_id) {
	      return setPredicateOperator_id(predicate, operator_id);
	    }
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__arguments"
	  }, /*#__PURE__*/React__default['default'].createElement(UIPredicateComparisonArgument, {
	    predicate: predicate
	  }))), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, /*#__PURE__*/React__default['default'].createElement(UIPredicateOptions, {
	    predicate: predicate
	  })));
	}
	UIPredicateComparison.propTypes = {
	  predicate: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object
	};

	function UIPredicateComparisonArgument(_ref) {
	  var predicate = _ref.predicate;

	  var _useUIPredicateContex = useUIPredicateContext(),
	      getArgumentTypeComponentById = _useUIPredicateContex.getArgumentTypeComponentById,
	      setArgumentValue = _useUIPredicateContex.setArgumentValue;

	  return /*#__PURE__*/React__default['default'].createElement(getArgumentTypeComponentById(predicate.operator.argumentType_id), {
	    predicate: predicate,
	    value: predicate.argument,
	    onChange: function onChange(value) {
	      setArgumentValue(predicate, value);
	    }
	  });
	}
	UIPredicateComparisonArgument.propTypes = {
	  predicate: PropTypes__default['default'].object
	};

	function UIPredicateCompound(_ref) {
	  var predicate = _ref.predicate,
	      columns = _ref.columns;

	  var _useUIPredicateContex = useUIPredicateContext(),
	      setPredicateLogicalType_id = _useUIPredicateContex.setPredicateLogicalType_id,
	      UITypes = _useUIPredicateContex.UITypes,
	      getUIComponent = _useUIPredicateContex.getUIComponent;

	  var LogicalTypesComponent = getUIComponent(UITypes.LOGICAL_TYPES);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__row--compound"
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__row"
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, predicate.logic && /*#__PURE__*/React__default['default'].createElement(LogicalTypesComponent, {
	    predicate: predicate,
	    columns: columns,
	    onChange: function onChange(logicalType_id) {
	      setPredicateLogicalType_id(predicate, logicalType_id);
	    }
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__col"
	  }, /*#__PURE__*/React__default['default'].createElement(UIPredicateOptions, {
	    predicate: predicate
	  }))), predicate.predicates.map(function (childPredicate, index) {
	    var ChildPredicateComponent = function () {
	      if (childPredicate.$_type === 'CompoundPredicate') return UIPredicateCompound;
	      if (childPredicate.$_type === 'ComparisonPredicate') return UIPredicateComparison;
	      return undefined;
	    }();

	    if (!ChildPredicateComponent) return null;
	    return /*#__PURE__*/React__default['default'].createElement(ChildPredicateComponent, {
	      key: index,
	      predicate: childPredicate,
	      columns: columns
	    });
	  }));
	}
	UIPredicateCompound.propTypes = {
	  predicate: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object
	};

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;

	  var _s, _e;

	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }

	  return arr2;
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}

	var uiPredicateCore = {exports: {}};

	(function (module, exports) {
	parcelRequire=function(e,r,t,n){var i,o="function"==typeof parcelRequire&&parcelRequire,u="function"==typeof commonjsRequire&&commonjsRequire;function f(t,n){if(!r[t]){if(!e[t]){var i="function"==typeof parcelRequire&&parcelRequire;if(!n&&i)return i(t,!0);if(o)return o(t,!0);if(u&&"string"==typeof t)return u(t);var c=new Error("Cannot find module '"+t+"'");throw c.code="MODULE_NOT_FOUND",c}p.resolve=function(r){return e[t][1][r]||r},p.cache={};var l=r[t]=new f.Module(t);e[t][0].call(l.exports,p,l,l.exports,this);}return r[t].exports;function p(e){return f(p.resolve(e))}}f.isParcelRequire=!0,f.Module=function(e){this.id=e,this.bundle=f,this.exports={};},f.modules=e,f.cache=r,f.parent=o,f.register=function(r,t){e[r]=[function(e,r){r.exports=t;},{}];};for(var c=0;c<t.length;c++)try{f(t[c]);}catch(e){i||(i=e);}if(t.length){var l=f(t[t.length-1]);module.exports=l;}if(parcelRequire=f,i)throw i;return f}({"ju5B":[function(require,module,exports) {
	function t(t,e){return Object.prototype.hasOwnProperty.call(e,t)}module.exports=t;
	},{}],"iTGZ":[function(require,module,exports) {
	var n=require("./_has");function r(r){if(null==r)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(r),o=1,t=arguments.length;o<t;){var i=arguments[o];if(null!=i)for(var u in i)n(u,i)&&(e[u]=i[u]);o+=1;}return e}module.exports="function"==typeof Object.assign?Object.assign:r;
	},{"./_has":"ju5B"}],"nGp2":[function(require,module,exports) {
	function e(e){return null!=e&&"object"==typeof e&&!0===e["@@functional/placeholder"]}module.exports=e;
	},{}],"hciU":[function(require,module,exports) {
	var e=require("./_isPlaceholder");function r(r){return function n(t){return 0===arguments.length||e(t)?n:r.apply(this,arguments)}}module.exports=r;
	},{"./_isPlaceholder":"nGp2"}],"rcw2":[function(require,module,exports) {
	var r=require("./internal/_objectAssign"),e=require("./internal/_curry1"),n=e(function(e){return r.apply(null,[{}].concat(e))});module.exports=n;
	},{"./internal/_objectAssign":"iTGZ","./internal/_curry1":"hciU"}],"vexR":[function(require,module,exports) {
	module.exports=function(o){return o&&"object"==typeof o&&"function"==typeof o.copy&&"function"==typeof o.fill&&"function"==typeof o.readUInt8};
	},{}],"Bm0n":[function(require,module,exports) {
	"function"==typeof Object.create?module.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}});}:module.exports=function(t,e){t.super_=e;var o=function(){};o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t;};
	},{}],"pBGv":[function(require,module,exports) {

	var t,e,n=module.exports={};function r(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function i(e){if(t===setTimeout)return setTimeout(e,0);if((t===r||!t)&&setTimeout)return t=setTimeout,setTimeout(e,0);try{return t(e,0)}catch(n){try{return t.call(null,e,0)}catch(n){return t.call(this,e,0)}}}function u(t){if(e===clearTimeout)return clearTimeout(t);if((e===o||!e)&&clearTimeout)return e=clearTimeout,clearTimeout(t);try{return e(t)}catch(n){try{return e.call(null,t)}catch(n){return e.call(this,t)}}}!function(){try{t="function"==typeof setTimeout?setTimeout:r;}catch(n){t=r;}try{e="function"==typeof clearTimeout?clearTimeout:o;}catch(n){e=o;}}();var c,s=[],l=!1,a=-1;function f(){l&&c&&(l=!1,c.length?s=c.concat(s):a=-1,s.length&&h());}function h(){if(!l){var t=i(f);l=!0;for(var e=s.length;e;){for(c=s,s=[];++a<e;)c&&c[a].run();a=-1,e=s.length;}c=null,l=!1,u(t);}}function m(t,e){this.fun=t,this.array=e;}function p(){}n.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];s.push(new m(t,e)),1!==s.length||l||i(h);},m.prototype.run=function(){this.fun.apply(null,this.array);},n.title="browser",n.env={},n.argv=[],n.version="",n.versions={},n.on=p,n.addListener=p,n.once=p,n.off=p,n.removeListener=p,n.removeAllListeners=p,n.emit=p,n.prependListener=p,n.prependOnceListener=p,n.listeners=function(t){return []},n.binding=function(t){throw new Error("process.binding is not supported")},n.cwd=function(){return "/"},n.chdir=function(t){throw new Error("process.chdir is not supported")},n.umask=function(){return 0};
	},{}],"gfUn":[function(require,module,exports) {
	require("process");
	var e=require("process"),t=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),r={},n=0;n<t.length;n++)r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n]);return r},r=/%[sdj%]/g;exports.format=function(e){if(!v(e)){for(var t=[],n=0;n<arguments.length;n++)t.push(i(arguments[n]));return t.join(" ")}n=1;for(var o=arguments,u=o.length,s=String(e).replace(r,function(e){if("%%"===e)return "%";if(n>=u)return e;switch(e){case"%s":return String(o[n++]);case"%d":return Number(o[n++]);case"%j":try{return JSON.stringify(o[n++])}catch(t){return "[Circular]"}default:return e}}),c=o[n];n<u;c=o[++n])h(c)||!S(c)?s+=" "+c:s+=" "+i(c);return s},exports.deprecate=function(t,r){if(void 0!==e&&!0===e.noDeprecation)return t;if(void 0===e)return function(){return exports.deprecate(t,r).apply(this,arguments)};var n=!1;return function(){if(!n){if(e.throwDeprecation)throw new Error(r);e.traceDeprecation?console.trace(r):console.error(r),n=!0;}return t.apply(this,arguments)}};var n,o={};function i(e,t){var r={seen:[],stylize:s};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),b(t)?r.showHidden=t:t&&exports._extend(r,t),j(r.showHidden)&&(r.showHidden=!1),j(r.depth)&&(r.depth=2),j(r.colors)&&(r.colors=!1),j(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=u),p(r,e,r.depth)}function u(e,t){var r=i.styles[t];return r?"["+i.colors[r][0]+"m"+e+"["+i.colors[r][1]+"m":e}function s(e,t){return e}function c(e){var t={};return e.forEach(function(e,r){t[e]=!0;}),t}function p(e,t,r){if(e.customInspect&&t&&P(t.inspect)&&t.inspect!==exports.inspect&&(!t.constructor||t.constructor.prototype!==t)){var n=t.inspect(r,e);return v(n)||(n=p(e,n,r)),n}var o=l(e,t);if(o)return o;var i=Object.keys(t),u=c(i);if(e.showHidden&&(i=Object.getOwnPropertyNames(t)),E(t)&&(i.indexOf("message")>=0||i.indexOf("description")>=0))return f(t);if(0===i.length){if(P(t)){var s=t.name?": "+t.name:"";return e.stylize("[Function"+s+"]","special")}if(w(t))return e.stylize(RegExp.prototype.toString.call(t),"regexp");if(z(t))return e.stylize(Date.prototype.toString.call(t),"date");if(E(t))return f(t)}var b,h="",m=!1,x=["{","}"];(d(t)&&(m=!0,x=["[","]"]),P(t))&&(h=" [Function"+(t.name?": "+t.name:"")+"]");return w(t)&&(h=" "+RegExp.prototype.toString.call(t)),z(t)&&(h=" "+Date.prototype.toUTCString.call(t)),E(t)&&(h=" "+f(t)),0!==i.length||m&&0!=t.length?r<0?w(t)?e.stylize(RegExp.prototype.toString.call(t),"regexp"):e.stylize("[Object]","special"):(e.seen.push(t),b=m?a(e,t,r,u,i):i.map(function(n){return y(e,t,r,u,n,m)}),e.seen.pop(),g(b,h,x)):x[0]+h+x[1]}function l(e,t){if(j(t))return e.stylize("undefined","undefined");if(v(t)){var r="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(r,"string")}return x(t)?e.stylize(""+t,"number"):b(t)?e.stylize(""+t,"boolean"):h(t)?e.stylize("null","null"):void 0}function f(e){return "["+Error.prototype.toString.call(e)+"]"}function a(e,t,r,n,o){for(var i=[],u=0,s=t.length;u<s;++u)A(t,String(u))?i.push(y(e,t,r,n,String(u),!0)):i.push("");return o.forEach(function(o){o.match(/^\d+$/)||i.push(y(e,t,r,n,o,!0));}),i}function y(e,t,r,n,o,i){var u,s,c;if((c=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]}).get?s=c.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):c.set&&(s=e.stylize("[Setter]","special")),A(n,o)||(u="["+o+"]"),s||(e.seen.indexOf(c.value)<0?(s=h(r)?p(e,c.value,null):p(e,c.value,r-1)).indexOf("\n")>-1&&(s=i?s.split("\n").map(function(e){return "  "+e}).join("\n").substr(2):"\n"+s.split("\n").map(function(e){return "   "+e}).join("\n")):s=e.stylize("[Circular]","special")),j(u)){if(i&&o.match(/^\d+$/))return s;(u=JSON.stringify(""+o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(u=u.substr(1,u.length-2),u=e.stylize(u,"name")):(u=u.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),u=e.stylize(u,"string"));}return u+": "+s}function g(e,t,r){return e.reduce(function(e,t){return t.indexOf("\n")>=0&&0,e+t.replace(/\u001b\[\d\d?m/g,"").length+1},0)>60?r[0]+(""===t?"":t+"\n ")+" "+e.join(",\n  ")+" "+r[1]:r[0]+t+" "+e.join(", ")+" "+r[1]}function d(e){return Array.isArray(e)}function b(e){return "boolean"==typeof e}function h(e){return null===e}function m(e){return null==e}function x(e){return "number"==typeof e}function v(e){return "string"==typeof e}function O(e){return "symbol"==typeof e}function j(e){return void 0===e}function w(e){return S(e)&&"[object RegExp]"===T(e)}function S(e){return "object"==typeof e&&null!==e}function z(e){return S(e)&&"[object Date]"===T(e)}function E(e){return S(e)&&("[object Error]"===T(e)||e instanceof Error)}function P(e){return "function"==typeof e}function D(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e}function T(e){return Object.prototype.toString.call(e)}function N(e){return e<10?"0"+e.toString(10):e.toString(10)}exports.debuglog=function(t){if(j(n)&&(n=""),t=t.toUpperCase(),!o[t])if(new RegExp("\\b"+t+"\\b","i").test(n)){var r=e.pid;o[t]=function(){var e=exports.format.apply(exports,arguments);console.error("%s %d: %s",t,r,e);};}else o[t]=function(){};return o[t]},exports.inspect=i,i.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},i.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"},exports.isArray=d,exports.isBoolean=b,exports.isNull=h,exports.isNullOrUndefined=m,exports.isNumber=x,exports.isString=v,exports.isSymbol=O,exports.isUndefined=j,exports.isRegExp=w,exports.isObject=S,exports.isDate=z,exports.isError=E,exports.isFunction=P,exports.isPrimitive=D,exports.isBuffer=require("./support/isBuffer");var F=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function k(){var e=new Date,t=[N(e.getHours()),N(e.getMinutes()),N(e.getSeconds())].join(":");return [e.getDate(),F[e.getMonth()],t].join(" ")}function A(e,t){return Object.prototype.hasOwnProperty.call(e,t)}exports.log=function(){console.log("%s - %s",k(),exports.format.apply(exports,arguments));},exports.inherits=require("inherits"),exports._extend=function(e,t){if(!t||!S(t))return e;for(var r=Object.keys(t),n=r.length;n--;)e[r[n]]=t[r[n]];return e};var J="undefined"!=typeof Symbol?Symbol("util.promisify.custom"):void 0;function R(e,t){if(!e){var r=new Error("Promise was rejected with a falsy value");r.reason=e,e=r;}return t(e)}function H(r){if("function"!=typeof r)throw new TypeError('The "original" argument must be of type Function');function n(){for(var t=[],n=0;n<arguments.length;n++)t.push(arguments[n]);var o=t.pop();if("function"!=typeof o)throw new TypeError("The last argument must be of type Function");var i=this,u=function(){return o.apply(i,arguments)};r.apply(this,t).then(function(t){e.nextTick(u,null,t);},function(t){e.nextTick(R,t,u);});}return Object.setPrototypeOf(n,Object.getPrototypeOf(r)),Object.defineProperties(n,t(r)),n}exports.promisify=function(e){if("function"!=typeof e)throw new TypeError('The "original" argument must be of type Function');if(J&&e[J]){var r;if("function"!=typeof(r=e[J]))throw new TypeError('The "util.promisify.custom" argument must be of type Function');return Object.defineProperty(r,J,{value:r,enumerable:!1,writable:!1,configurable:!0}),r}function r(){for(var t,r,n=new Promise(function(e,n){t=e,r=n;}),o=[],i=0;i<arguments.length;i++)o.push(arguments[i]);o.push(function(e,n){e?r(e):t(n);});try{e.apply(this,o);}catch(u){r(u);}return n}return Object.setPrototypeOf(r,Object.getPrototypeOf(e)),J&&Object.defineProperty(r,J,{value:r,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(r,t(e))},exports.promisify.custom=J,exports.callbackify=H;
	},{"./support/isBuffer":"vexR","inherits":"Bm0n","process":"pBGv"}],"kB4W":[function(require,module,exports) {
	module.exports=function(n){return !!n&&(n instanceof Array||Array.isArray(n)||n.length>=0&&n.splice instanceof Function)};
	},{}],"IBov":[function(require,module,exports) {
	var e=require("util"),r=require("is-arrayish"),t=function(t,n){t&&t.constructor===String||(n=t||{},t=Error.name);var i=function e(s){if(!this)return new e(s);s=s instanceof Error?s.message:s||this.message,Error.call(this,s),Error.captureStackTrace(this,i),this.name=t,Object.defineProperty(this,"message",{configurable:!0,enumerable:!1,get:function(){var e=s.split(/\r?\n/g);for(var t in n)if(n.hasOwnProperty(t)){var i=n[t];"message"in i&&(e=i.message(this[t],e)||e,r(e)||(e=[e]));}return e.join("\n")},set:function(e){s=e;}});var o=null,a=Object.getOwnPropertyDescriptor(this,"stack"),c=a.get,u=a.value;delete a.value,delete a.writable,a.set=function(e){o=e;},a.get=function(){var e=(o||(c?c.call(this):u)).split(/\r?\n+/g);o||(e[0]=this.name+": "+this.message);var r=1;for(var t in n)if(n.hasOwnProperty(t)){var i=n[t];if("line"in i){var s=i.line(this[t]);s&&e.splice(r++,0,"    "+s);}"stack"in i&&i.stack(this[t],e);}return e.join("\n")},Object.defineProperty(this,"stack",a);};return Object.setPrototypeOf?(Object.setPrototypeOf(i.prototype,Error.prototype),Object.setPrototypeOf(i,Error)):e.inherits(i,Error),i};t.append=function(e,r){return {message:function(t,n){return (t=t||r)&&(n[0]+=" "+e.replace("%s",t.toString())),n}}},t.line=function(e,r){return {line:function(t){return (t=t||r)?e.replace("%s",t.toString()):null}}},module.exports=t;
	},{"util":"gfUn","is-arrayish":"kB4W"}],"p8GN":[function(require,module,exports) {
	function e(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}var r=require("ramda/src/mergeAll"),t=require("error-ex");function o(r){return e({},r,t(r))}module.exports=r([o("InvalidPredicateType"),o("UnknownJSONData"),o("CompoundPredicateMustHaveAtLeastOneSubPredicate"),o("RootPredicateMustBeACompoundPredicate"),o("PredicateMustBeACompoundPredicate"),o("PredicateMustBeAComparisonPredicate"),o("AddCurrentlyOnlySupportAfterInsertion"),o("TargetMustReferToADefinedType"),o("LogicalType_idMustReferToADefinedLogicalType"),o("Target_idMustReferToADefinedTarget"),o("Operator_idMustReferToADefinedOperator"),o("Operator_idMustReferToADefinedOperator"),o("ForbiddenCannotRemoveRootCompoundPredicate"),o("ForbiddenCannotRemoveLastComparisonPredicate"),o("CannotRemoveSomethingElseThanACompoundPredicateOrAComparisonPredicate"),o("CannotAddSomethingElseThanACompoundPredicateOrAComparisonPredicate"),o("UIFrameworkMustImplementgetDefaultArgumentComponent")]);
	},{"ramda/src/mergeAll":"rcw2","error-ex":"IBov"}],"lIRz":[function(require,module,exports) {
	module.exports={TARGETS:"TARGETS",LOGICAL_TYPES:"LOGICAL_TYPES",OPERATORS:"OPERATORS",PREDICATE_ADD:"PREDICATE_ADD",PREDICATE_REMOVE:"PREDICATE_REMOVE",ARGUMENT_DEFAULT:"ARGUMENT_DEFAULT"};
	},{}],"vQMb":[function(require,module,exports) {
	module.exports={predicateToRemoveIsRootPredicate:function(e,o){return e===o},predicateToRemoveIsTheLastComparisonPredicate:function(e,o,r){return 1===o.reduce(e,function(e,o){return r.is(o)?e+1:e},0)}};
	},{}],"DfgV":[function(require,module,exports) {
	module.exports=function(e){var r=e.errors,t=e.rules;return {CompoundPredicateMustHaveAtLeastOneSubPredicate:function(e){return Array.isArray(e)&&0!==e.length?Promise.resolve():Promise.reject(new r.CompoundPredicateMustHaveAtLeastOneSubPredicate)},PredicateTypeMustBeValid:function(e,t){return Object.keys(t).includes(e)?Promise.resolve():Promise.reject(new r.InvalidPredicateType)},RootPredicateMustBeACompoundPredicate:function(e,t){return t.is(e)?Promise.resolve(e):Promise.reject(new r.RootPredicateMustBeACompoundPredicate)},PredicateMustBeAComparisonPredicate:function(e,t){return t.is(e)?Promise.resolve():Promise.reject(new r.PredicateMustBeAComparisonPredicate)},PredicateMustBeACompoundPredicate:function(e,t){return t.is(e)?Promise.resolve():Promise.reject(new r.PredicateMustBeACompoundPredicate)},AddOnlySupportsAfter:function(e){return "after"!==e?Promise.reject(new r.AddCurrentlyOnlySupportAfterInsertion):Promise.resolve()},TargetMustReferToADefinedType:function(e,t){return e.isNone()?Promise.reject(new r.TargetMustReferToADefinedType("target ".concat(JSON.stringify(t.target_id)," does not refer to a defined type, target.type_id=").concat(JSON.stringify(t.type_id)))):Promise.resolve(e.value())},LogicalType_idMustReferToADefinedLogicalType:function(e){return e?Promise.resolve(e):Promise.reject(new r.LogicalType_idMustReferToADefinedLogicalType)},Target_idMustReferToADefinedTarget:function(e){return e?Promise.resolve(e):Promise.reject(new r.Target_idMustReferToADefinedTarget)},Operator_idMustReferToADefinedOperator:function(e){return e?Promise.resolve(e):Promise.reject(new r.Operator_idMustReferToADefinedOperator)},RemovePredicateMustDifferFromRootPredicate:function(e,o){return t.predicateToRemoveIsRootPredicate(e,o)?Promise.reject(new r.ForbiddenCannotRemoveRootCompoundPredicate):Promise.resolve(o)},RemovePredicateCannotBeTheLastComparisonPredicate:function(e,o,i,n){return n.is(o)&&t.predicateToRemoveIsTheLastComparisonPredicate(e,i,n)?Promise.reject(new r.ForbiddenCannotRemoveLastComparisonPredicate):Promise.resolve()}}};
	},{}],"lfLW":[function(require,module,exports) {
	var r=require("./_curry1"),e=require("./_isPlaceholder");function n(n){return function u(t,c){switch(arguments.length){case 0:return u;case 1:return e(t)?u:r(function(r){return n(t,r)});default:return e(t)&&e(c)?u:e(t)?r(function(r){return n(r,c)}):e(c)?r(function(r){return n(t,r)}):n(t,c)}}}module.exports=n;
	},{"./_curry1":"hciU","./_isPlaceholder":"nGp2"}],"mgRa":[function(require,module,exports) {
	var r=require("./internal/_objectAssign"),e=require("./internal/_curry2"),n=e(function(e,n){return r({},e,n)});module.exports=n;
	},{"./internal/_objectAssign":"iTGZ","./internal/_curry2":"lfLW"}],"gPT3":[function(require,module,exports) {
	var r=require("./internal/_curry1"),e="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff",t="​",n="function"==typeof String.prototype.trim,u=r(n&&!e.trim()&&t.trim()?function(r){return r.trim()}:function(r){var t=new RegExp("^["+e+"]["+e+"]*"),n=new RegExp("["+e+"]["+e+"]*$");return r.replace(t,"").replace(n,"")});module.exports=u;
	},{"./internal/_curry1":"hciU"}],"AXYj":[function(require,module,exports) {
	module.exports=function(e){return {$_type:e}};
	},{}],"XRoj":[function(require,module,exports) {
	var r=require("ramda/src/mergeAll"),e=require("ramda/src/trim"),t=require("./$_type");function o(e){var o=d(e,"target_id,label,type_id"),i=o.target_id,a=o.label,n=o.type_id;return r([t("Target"),{target_id:i,label:a,type_id:n},e])}function i(e){var o=d(e,"operator_id,label,argumentType_id"),i=o.operator_id,a=o.label,n=o.argumentType_id;return r([t("Operator"),{operator_id:i,argumentType_id:n,label:a},e])}function a(e){var o=d(e,"type_id,operator_ids"),i=o.type_id,a=o.operator_ids;return r([t("Type"),{type_id:i,operator_ids:a},e])}function n(e){var o=d(e,"logicalType_id,label"),i=o.logicalType_id,a=o.label;return r([t("LogicalType"),{logicalType_id:i,label:a},e])}function p(e){var o=d(e,"argumentType_id,component"),i=o.argumentType_id,a=o.component;return r([t("ArgumentType"),{argumentType_id:i,component:a},e])}o.toJSON=function(r){return {target_id:r.target_id}},i.toJSON=function(r){return {operator_id:r.operator_id}},n.toJSON=function(r){return {logicalType_id:r.logicalType_id}};var l=Object.prototype.toString;function c(r){return "[object Object]"===l.call(r)}function d(r,t){if(!c(r))throw new Error("Object is required, got: ".concat(JSON.stringify(r),"."));for(var o,i=t.split(",").map(e);o=i.pop();)if(!r.hasOwnProperty(o))throw new Error("Object ".concat(JSON.stringify(r)," MUST have a '").concat(o,"' property."));return r}module.exports={Type:a,Target:o,Operator:i,LogicalType:n,ArgumentType:p,_requireProps:d};
	},{"ramda/src/mergeAll":"rcw2","ramda/src/trim":"gPT3","./$_type":"AXYj"}],"inM9":[function(require,module,exports) {
	function e(e,o){return n(e)||t(e,o)||r()}function r(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function t(e,r){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){var t=[],n=!0,o=!1,i=void 0;try{for(var u,a=e[Symbol.iterator]();!(n=(u=a.next()).done)&&(t.push(u.value),!r||t.length!==r);n=!0);}catch(c){o=!0,i=c;}finally{try{n||null==a.return||a.return();}finally{if(o)throw i}}return t}}function n(e){if(Array.isArray(e))return e}var o=require("ramda/src/merge"),i=require("ramda/src/mergeAll"),u=require("./$_type");module.exports=function(r){var t=r.invariants,n=r.errors,a=require("./columns"),c=a.Target,d=a.Operator,m=a.LogicalType;function p(e){return t.PredicateTypeMustBeValid(e.$name,p.Types).then(function(){return o(u(e.$name),{$canBeRemoved:!0})})}function f(e,r){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;return p(f).then(function(n){return o(n,{target:e,operator:r,argument:t})})}function s(e,r){return t.CompoundPredicateMustHaveAtLeastOneSubPredicate(r,s).then(function(){return p(s)}).then(function(t){return o(t,{logic:e,predicates:r})})}return p.toJSON=function(e){return f.is(e)?f.toJSON(e):s.toJSON(e)},p.fromJSON=function(e,r){return f.isFromJSON(e)?f.fromJSON(e,r):s.isFromJSON(e)?s.fromJSON(e,r):Promise.reject(new n.UnknownJSONData)},p.Types={ComparisonPredicate:"ComparisonPredicate",CompoundPredicate:"CompoundPredicate"},f.$name=p.Types.ComparisonPredicate,f.toJSON=function(e){return i([c.toJSON(e.target),d.toJSON(e.operator),{argument:e.argument}])},f.fromJSON=function(r,t){return Promise.all([t.getTargetById(r.target_id),t.getOperatorById(r.operator_id)]).then(function(t){var n=e(t,2);return f(n[0],n[1],r.argument)})},f.is=function(e){return e&&e.$_type===p.Types.ComparisonPredicate},f.isFromJSON=function(e){return e&&e.target_id},s.$name=p.Types.CompoundPredicate,s.toJSON=function(e){return i([m.toJSON(e.logic),{predicates:e.predicates.map(p.toJSON)}])},s.fromJSON=function(e,r){return t.CompoundPredicateMustHaveAtLeastOneSubPredicate(e.predicates,s).then(function(){return r.getLogicalTypeById(e.logicalType_id)}).then(function(t){return Promise.all(e.predicates.map(function(e){return p.fromJSON(e,r)})).then(function(e){return s(t,e)})})},s.reduce=function(e,r,t){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[],o=r(t,e,n);return e.predicates.reduce(function(t,o,i){var u=n.concat([e,[o,i]]);return s.is(o)?s.reduce(o,r,t,u):r(t,o,u)},o)},s.forEach=function(e,r){s.reduce(e,function(e,t){r(t);},null);},s.is=function(e){return e&&e.$_type===p.Types.CompoundPredicate},s.isFromJSON=function(e){return e&&e.logicalType_id},{Predicate:p,ComparisonPredicate:f,CompoundPredicate:s}};
	},{"ramda/src/merge":"mgRa","ramda/src/mergeAll":"rcw2","./$_type":"AXYj","./columns":"XRoj"}],"wTLu":[function(require,module,exports) {
	var r=require("ramda/src/merge");module.exports=function(e){return r(require("./columns"),require("./predicates")(e))};
	},{"ramda/src/merge":"mgRa","./columns":"XRoj","./predicates":"inM9"}],"XYKd":[function(require,module,exports) {
	module.exports=Array.isArray||function(r){return null!=r&&r.length>=0&&"[object Array]"===Object.prototype.toString.call(r)};
	},{}],"DNFd":[function(require,module,exports) {
	function n(n){return null!=n&&"function"==typeof n["@@transducer/step"]}module.exports=n;
	},{}],"YhHl":[function(require,module,exports) {
	var r=require("./_isArray"),e=require("./_isTransformer");function n(n,t,i){return function(){if(0===arguments.length)return i();var p=Array.prototype.slice.call(arguments,0),u=p.pop();if(!r(u)){for(var l=0;l<n.length;){if("function"==typeof u[n[l]])return u[n[l]].apply(u,p);l+=1;}if(e(u))return t.apply(null,p)(u)}return i.apply(this,arguments)}}module.exports=n;
	},{"./_isArray":"XYKd","./_isTransformer":"DNFd"}],"HHz7":[function(require,module,exports) {
	function e(e){return e&&e["@@transducer/reduced"]?e:{"@@transducer/value":e,"@@transducer/reduced":!0}}module.exports=e;
	},{}],"qFL6":[function(require,module,exports) {
	module.exports={init:function(){return this.xf["@@transducer/init"]()},result:function(t){return this.xf["@@transducer/result"](t)}};
	},{}],"rYJD":[function(require,module,exports) {
	var t=require("./_curry2"),r=require("./_reduced"),e=require("./_xfBase"),n=function(){function t(t,r){this.xf=r,this.f=t,this.found=!1;}return t.prototype["@@transducer/init"]=e.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,void 0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)&&(this.found=!0,t=r(this.xf["@@transducer/step"](t,e))),t},t}(),u=t(function(t,r){return new n(t,r)});module.exports=u;
	},{"./_curry2":"lfLW","./_reduced":"HHz7","./_xfBase":"qFL6"}],"uq3h":[function(require,module,exports) {
	var r=require("./internal/_curry2"),e=require("./internal/_dispatchable"),n=require("./internal/_xfind"),i=r(e(["find"],n,function(r,e){for(var n=0,i=e.length;n<i;){if(r(e[n]))return e[n];n+=1;}}));module.exports=i;
	},{"./internal/_curry2":"lfLW","./internal/_dispatchable":"YhHl","./internal/_xfind":"rYJD"}],"Q8ih":[function(require,module,exports) {
	function t(t,n){switch(t){case 0:return function(){return n.apply(this,arguments)};case 1:return function(t){return n.apply(this,arguments)};case 2:return function(t,r){return n.apply(this,arguments)};case 3:return function(t,r,e){return n.apply(this,arguments)};case 4:return function(t,r,e,u){return n.apply(this,arguments)};case 5:return function(t,r,e,u,a){return n.apply(this,arguments)};case 6:return function(t,r,e,u,a,i){return n.apply(this,arguments)};case 7:return function(t,r,e,u,a,i,s){return n.apply(this,arguments)};case 8:return function(t,r,e,u,a,i,s,c){return n.apply(this,arguments)};case 9:return function(t,r,e,u,a,i,s,c,p){return n.apply(this,arguments)};case 10:return function(t,r,e,u,a,i,s,c,p,o){return n.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}module.exports=t;
	},{}],"yyrF":[function(require,module,exports) {
	var r=require("./_arity"),e=require("./_isPlaceholder");function t(n,l,i){return function(){for(var u=[],a=0,h=n,o=0;o<l.length||a<arguments.length;){var g;o<l.length&&(!e(l[o])||a>=arguments.length)?g=l[o]:(g=arguments[a],a+=1),u[o]=g,e(g)||(h-=1),o+=1;}return h<=0?i.apply(this,u):r(h,t(n,u,i))}}module.exports=t;
	},{"./_arity":"Q8ih","./_isPlaceholder":"nGp2"}],"RWhc":[function(require,module,exports) {
	var r=require("./internal/_arity"),e=require("./internal/_curry1"),n=require("./internal/_curry2"),i=require("./internal/_curryN"),u=n(function(n,u){return 1===n?e(u):r(n,i(n,[],u))});module.exports=u;
	},{"./internal/_arity":"Q8ih","./internal/_curry1":"hciU","./internal/_curry2":"lfLW","./internal/_curryN":"yyrF"}],"UkKV":[function(require,module,exports) {
	var r=require("./internal/_curry1"),e=require("./curryN"),u=r(function(r){return e(r.length,r)});module.exports=u;
	},{"./internal/_curry1":"hciU","./curryN":"RWhc"}],"tXEM":[function(require,module,exports) {
	function t(t,n){return function(){return n.call(this,t.apply(this,arguments))}}module.exports=t;
	},{}],"sZV2":[function(require,module,exports) {
	var r=require("./_curry1"),n=require("./_curry2"),u=require("./_isPlaceholder");function t(t){return function e(c,i,o){switch(arguments.length){case 0:return e;case 1:return u(c)?e:n(function(r,n){return t(c,r,n)});case 2:return u(c)&&u(i)?e:u(c)?n(function(r,n){return t(r,i,n)}):u(i)?n(function(r,n){return t(c,r,n)}):r(function(r){return t(c,i,r)});default:return u(c)&&u(i)&&u(o)?e:u(c)&&u(i)?n(function(r,n){return t(r,n,o)}):u(c)&&u(o)?n(function(r,n){return t(r,i,n)}):u(i)&&u(o)?n(function(r,n){return t(c,r,n)}):u(c)?r(function(r){return t(r,i,o)}):u(i)?r(function(r){return t(c,r,o)}):u(o)?r(function(r){return t(c,i,r)}):t(c,i,o)}}}module.exports=t;
	},{"./_curry1":"hciU","./_curry2":"lfLW","./_isPlaceholder":"nGp2"}],"UJZr":[function(require,module,exports) {
	function t(t){return "[object String]"===Object.prototype.toString.call(t)}module.exports=t;
	},{}],"F4hA":[function(require,module,exports) {
	var e=require("./_curry1"),r=require("./_isArray"),t=require("./_isString"),n=e(function(e){return !!r(e)||!!e&&("object"==typeof e&&(!t(e)&&(1===e.nodeType?!!e.length:0===e.length||e.length>0&&(e.hasOwnProperty(0)&&e.hasOwnProperty(e.length-1)))))});module.exports=n;
	},{"./_curry1":"hciU","./_isArray":"XYKd","./_isString":"UJZr"}],"Vy1v":[function(require,module,exports) {
	var t=function(){function t(t){this.f=t;}return t.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},t.prototype["@@transducer/result"]=function(t){return t},t.prototype["@@transducer/step"]=function(t,n){return this.f(t,n)},t}();function n(n){return new t(n)}module.exports=n;
	},{}],"T9rr":[function(require,module,exports) {
	var r=require("./internal/_arity"),e=require("./internal/_curry2"),n=e(function(e,n){return r(e.length,function(){return e.apply(n,arguments)})});module.exports=n;
	},{"./internal/_arity":"Q8ih","./internal/_curry2":"lfLW"}],"E5VB":[function(require,module,exports) {
	var r=require("./_isArrayLike"),e=require("./_xwrap"),t=require("../bind");function n(r,e,t){for(var n=0,u=t.length;n<u;){if((e=r["@@transducer/step"](e,t[n]))&&e["@@transducer/reduced"]){e=e["@@transducer/value"];break}n+=1;}return r["@@transducer/result"](e)}function u(r,e,t){for(var n=t.next();!n.done;){if((e=r["@@transducer/step"](e,n.value))&&e["@@transducer/reduced"]){e=e["@@transducer/value"];break}n=t.next();}return r["@@transducer/result"](e)}function a(r,e,n,u){return r["@@transducer/result"](n[u](t(r["@@transducer/step"],r),e))}var d="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator";function i(t,i,c){if("function"==typeof t&&(t=e(t)),r(c))return n(t,i,c);if("function"==typeof c["fantasy-land/reduce"])return a(t,i,c,"fantasy-land/reduce");if(null!=c[d])return u(t,i,c[d]());if("function"==typeof c.next)return u(t,i,c);if("function"==typeof c.reduce)return a(t,i,c,"reduce");throw new TypeError("reduce: list must be array or iterable")}module.exports=i;
	},{"./_isArrayLike":"F4hA","./_xwrap":"Vy1v","../bind":"T9rr"}],"NfOJ":[function(require,module,exports) {
	var r=require("./internal/_curry3"),e=require("./internal/_reduce"),u=r(e);module.exports=u;
	},{"./internal/_curry3":"sZV2","./internal/_reduce":"E5VB"}],"pHif":[function(require,module,exports) {
	var r=require("./_isArray");function t(t,e){return function(){var n=arguments.length;if(0===n)return e();var a=arguments[n-1];return r(a)||"function"!=typeof a[t]?e.apply(this,arguments):a[t].apply(a,Array.prototype.slice.call(arguments,0,n-1))}}module.exports=t;
	},{"./_isArray":"XYKd"}],"TkIY":[function(require,module,exports) {
	var r=require("./internal/_checkForMethod"),e=require("./internal/_curry3"),t=e(r("slice",function(r,e,t){return Array.prototype.slice.call(t,r,e)}));module.exports=t;
	},{"./internal/_checkForMethod":"pHif","./internal/_curry3":"sZV2"}],"k3OO":[function(require,module,exports) {
	var e=require("./internal/_checkForMethod"),r=require("./internal/_curry1"),i=require("./slice"),l=r(e("tail",i(1,1/0)));module.exports=l;
	},{"./internal/_checkForMethod":"pHif","./internal/_curry1":"hciU","./slice":"TkIY"}],"RMMw":[function(require,module,exports) {
	var e=require("./internal/_arity"),r=require("./internal/_pipe"),i=require("./reduce"),t=require("./tail");function n(){if(0===arguments.length)throw new Error("pipe requires at least one argument");return e(arguments[0].length,i(r,arguments[0],t(arguments)))}module.exports=n;
	},{"./internal/_arity":"Q8ih","./internal/_pipe":"tXEM","./reduce":"NfOJ","./tail":"k3OO"}],"zBtk":[function(require,module,exports) {
	function e(e,n){for(var r=0,t=n.length,o=[];r<t;)e(n[r])&&(o[o.length]=n[r]),r+=1;return o}module.exports=e;
	},{}],"MoFR":[function(require,module,exports) {
	function t(t){return "[object Object]"===Object.prototype.toString.call(t)}module.exports=t;
	},{}],"PqT3":[function(require,module,exports) {
	var t=require("./_curry2"),r=require("./_xfBase"),e=function(){function t(t,r){this.xf=r,this.f=t;}return t.prototype["@@transducer/init"]=r.init,t.prototype["@@transducer/result"]=r.result,t.prototype["@@transducer/step"]=function(t,r){return this.f(r)?this.xf["@@transducer/step"](t,r):t},t}(),n=t(function(t,r){return new e(t,r)});module.exports=n;
	},{"./_curry2":"lfLW","./_xfBase":"qFL6"}],"vYr9":[function(require,module,exports) {
	var t=require("./_has"),e=Object.prototype.toString,r=function(){return "[object Arguments]"===e.call(arguments)?function(t){return "[object Arguments]"===e.call(t)}:function(e){return t("callee",e)}}();module.exports=r;
	},{"./_has":"ju5B"}],"gETM":[function(require,module,exports) {
	var r=require("./internal/_curry1"),e=require("./internal/_has"),t=require("./internal/_isArguments"),n=!{toString:null}.propertyIsEnumerable("toString"),o=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],u=function(){return arguments.propertyIsEnumerable("length")}(),i=function(r,e){for(var t=0;t<r.length;){if(r[t]===e)return !0;t+=1;}return !1},l="function"!=typeof Object.keys||u?r(function(r){if(Object(r)!==r)return [];var l,c,f=[],s=u&&t(r);for(l in r)!e(l,r)||s&&"length"===l||(f[f.length]=l);if(n)for(c=o.length-1;c>=0;)l=o[c],e(l,r)&&!i(f,l)&&(f[f.length]=l),c-=1;return f}):r(function(r){return Object(r)!==r?[]:Object.keys(r)});module.exports=l;
	},{"./internal/_curry1":"hciU","./internal/_has":"ju5B","./internal/_isArguments":"vYr9"}],"h7VV":[function(require,module,exports) {
	var e=require("./internal/_curry2"),r=require("./internal/_dispatchable"),i=require("./internal/_filter"),n=require("./internal/_isObject"),t=require("./internal/_reduce"),u=require("./internal/_xfilter"),l=require("./keys"),a=e(r(["filter"],u,function(e,r){return n(r)?t(function(i,n){return e(r[n])&&(i[n]=r[n]),i},{},l(r)):i(e,r)}));module.exports=a;
	},{"./internal/_curry2":"lfLW","./internal/_dispatchable":"YhHl","./internal/_filter":"zBtk","./internal/_isObject":"MoFR","./internal/_reduce":"E5VB","./internal/_xfilter":"PqT3","./keys":"gETM"}],"mSaf":[function(require,module,exports) {
	function r(r,e){for(var n=0,o=e.length,t=Array(o);n<o;)t[n]=r(e[n]),n+=1;return t}module.exports=r;
	},{}],"x8vF":[function(require,module,exports) {
	var t=require("./_curry2"),r=require("./_xfBase"),e=function(){function t(t,r){this.xf=r,this.f=t;}return t.prototype["@@transducer/init"]=r.init,t.prototype["@@transducer/result"]=r.result,t.prototype["@@transducer/step"]=function(t,r){return this.xf["@@transducer/step"](t,this.f(r))},t}(),n=t(function(t,r){return new e(t,r)});module.exports=n;
	},{"./_curry2":"lfLW","./_xfBase":"qFL6"}],"Bsaj":[function(require,module,exports) {
	var e=require("./internal/_curry2"),r=require("./internal/_dispatchable"),t=require("./internal/_map"),n=require("./internal/_reduce"),a=require("./internal/_xmap"),i=require("./curryN"),u=require("./keys"),c=e(r(["fantasy-land/map","map"],a,function(e,r){switch(Object.prototype.toString.call(r)){case"[object Function]":return i(r.length,function(){return e.call(this,r.apply(this,arguments))});case"[object Object]":return n(function(t,n){return t[n]=e(r[n]),t},{},u(r));default:return t(e,r)}}));module.exports=c;
	},{"./internal/_curry2":"lfLW","./internal/_dispatchable":"YhHl","./internal/_map":"mSaf","./internal/_reduce":"E5VB","./internal/_xmap":"x8vF","./curryN":"RWhc","./keys":"gETM"}],"pzqo":[function(require,module,exports) {
	var t=require("./_curry2"),r=require("./_xfBase"),e=function(){function t(t,r){this.xf=r,this.n=t;}return t.prototype["@@transducer/init"]=r.init,t.prototype["@@transducer/result"]=r.result,t.prototype["@@transducer/step"]=function(t,r){return this.n>0?(this.n-=1,t):this.xf["@@transducer/step"](t,r)},t}(),n=t(function(t,r){return new e(t,r)});module.exports=n;
	},{"./_curry2":"lfLW","./_xfBase":"qFL6"}],"csMX":[function(require,module,exports) {
	var r=require("./internal/_curry2"),e=require("./internal/_dispatchable"),i=require("./internal/_xdrop"),n=require("./slice"),a=r(e(["drop"],i,function(r,e){return n(Math.max(0,r),1/0,e)}));module.exports=a;
	},{"./internal/_curry2":"lfLW","./internal/_dispatchable":"YhHl","./internal/_xdrop":"pzqo","./slice":"TkIY"}],"DeV3":[function(require,module,exports) {
	var r=require("./internal/_curry2"),e=require("./drop"),n=r(function(r,n){return e(r>=0?n.length-r:0,n)});module.exports=n;
	},{"./internal/_curry2":"lfLW","./drop":"csMX"}],"cEbX":[function(require,module,exports) {
	var r=require("./internal/_curry3"),e=r(function(r,e,l){r=r<l.length&&r>=0?r:l.length;var t=Array.prototype.slice.call(l,0);return t.splice(r,0,e),t});module.exports=e;
	},{"./internal/_curry3":"sZV2"}],"wygZ":[function(require,module,exports) {
	function n(n){return "function"==typeof n?n():n}exports.none=Object.create({value:function(){throw new Error("Called value on none")},isNone:function(){return !0},isSome:function(){return !1},map:function(){return exports.none},flatMap:function(){return exports.none},filter:function(){return exports.none},toArray:function(){return []},orElse:n,valueOrElse:n}),exports.some=function(n){return new t(n)};var t=function(n){this._value=n;};t.prototype.value=function(){return this._value},t.prototype.isNone=function(){return !1},t.prototype.isSome=function(){return !0},t.prototype.map=function(n){return new t(n(this._value))},t.prototype.flatMap=function(n){return n(this._value)},t.prototype.filter=function(n){return n(this._value)?this:exports.none},t.prototype.toArray=function(){return [this._value]},t.prototype.orElse=function(n){return this},t.prototype.valueOrElse=function(n){return this._value},exports.isOption=function(n){return n===exports.none||n instanceof t},exports.fromNullable=function(n){return null==n?exports.none:new t(n)};
	},{}],"FRpO":[function(require,module,exports) {
	var e,t="object"==typeof Reflect?Reflect:null,n=t&&"function"==typeof t.apply?t.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};function r(e){console&&console.warn&&console.warn(e);}e=t&&"function"==typeof t.ownKeys?t.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var i=Number.isNaN||function(e){return e!=e};function o(){o.init.call(this);}module.exports=o,o.EventEmitter=o,o.prototype._events=void 0,o.prototype._eventsCount=0,o.prototype._maxListeners=void 0;var s=10;function u(e){if("function"!=typeof e)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}function f(e){return void 0===e._maxListeners?o.defaultMaxListeners:e._maxListeners}function v(e,t,n,i){var o,s,v;if(u(n),void 0===(s=e._events)?(s=e._events=Object.create(null),e._eventsCount=0):(void 0!==s.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),s=e._events),v=s[t]),void 0===v)v=s[t]=n,++e._eventsCount;else if("function"==typeof v?v=s[t]=i?[n,v]:[v,n]:i?v.unshift(n):v.push(n),(o=f(e))>0&&v.length>o&&!v.warned){v.warned=!0;var l=new Error("Possible EventEmitter memory leak detected. "+v.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");l.name="MaxListenersExceededWarning",l.emitter=e,l.type=t,l.count=v.length,r(l);}return e}function l(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function a(e,t,n){var r={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},i=l.bind(r);return i.listener=n,r.wrapFn=i,i}function h(e,t,n){var r=e._events;if(void 0===r)return [];var i=r[t];return void 0===i?[]:"function"==typeof i?n?[i.listener||i]:[i]:n?d(i):c(i,i.length)}function p(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function c(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e[r];return n}function y(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop();}function d(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}Object.defineProperty(o,"defaultMaxListeners",{enumerable:!0,get:function(){return s},set:function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");s=e;}}),o.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0;},o.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},o.prototype.getMaxListeners=function(){return f(this)},o.prototype.emit=function(e){for(var t=[],r=1;r<arguments.length;r++)t.push(arguments[r]);var i="error"===e,o=this._events;if(void 0!==o)i=i&&void 0===o.error;else if(!i)return !1;if(i){var s;if(t.length>0&&(s=t[0]),s instanceof Error)throw s;var u=new Error("Unhandled error."+(s?" ("+s.message+")":""));throw u.context=s,u}var f=o[e];if(void 0===f)return !1;if("function"==typeof f)n(f,this,t);else {var v=f.length,l=c(f,v);for(r=0;r<v;++r)n(l[r],this,t);}return !0},o.prototype.addListener=function(e,t){return v(this,e,t,!1)},o.prototype.on=o.prototype.addListener,o.prototype.prependListener=function(e,t){return v(this,e,t,!0)},o.prototype.once=function(e,t){return u(t),this.on(e,a(this,e,t)),this},o.prototype.prependOnceListener=function(e,t){return u(t),this.prependListener(e,a(this,e,t)),this},o.prototype.removeListener=function(e,t){var n,r,i,o,s;if(u(t),void 0===(r=this._events))return this;if(void 0===(n=r[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete r[e],r.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(i=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){s=n[o].listener,i=o;break}if(i<0)return this;0===i?n.shift():y(n,i),1===n.length&&(r[e]=n[0]),void 0!==r.removeListener&&this.emit("removeListener",e,s||t);}return this},o.prototype.off=o.prototype.removeListener,o.prototype.removeAllListeners=function(e){var t,n,r;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var i,o=Object.keys(n);for(r=0;r<o.length;++r)"removeListener"!==(i=o[r])&&this.removeAllListeners(i);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(r=t.length-1;r>=0;r--)this.removeListener(e,t[r]);return this},o.prototype.listeners=function(e){return h(this,e,!0)},o.prototype.rawListeners=function(e){return h(this,e,!1)},o.listenerCount=function(e,t){return "function"==typeof e.listenerCount?e.listenerCount(t):p.call(e,t)},o.prototype.listenerCount=p,o.prototype.eventNames=function(){return this._eventsCount>0?e(this._events):[]};
	},{}],"Obe2":[function(require,module,exports) {
	function e(e,o){return n(e)||r(e,o)||t()}function t(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function r(e,t){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){var r=[],n=!0,o=!1,u=void 0;try{for(var i,a=e[Symbol.iterator]();!(n=(i=a.next()).done)&&(r.push(i.value),!t||r.length!==t);n=!0);}catch(c){o=!0,u=c;}finally{try{n||null==a.return||a.return();}finally{if(o)throw u}}return r}}function n(e){if(Array.isArray(e))return e}var o=require("ramda/src/merge"),u=require("ramda/src/find"),i=require("ramda/src/curry"),a=require("ramda/src/pipe"),c=require("ramda/src/filter"),s=require("ramda/src/map"),f=require("ramda/src/takeLast"),p=require("ramda/src/insert"),d=require("option"),l=require("events"),m=l.EventEmitter;function g(e){return d.fromNullable(e[0]).value()}module.exports=function(t){var r=t.dataclasses,n=t.invariants,l=t.errors,y=t.rules,h=t.UITypes,v=r.CompoundPredicate,T=r.ComparisonPredicate,P=r.Predicate,A=function(e,t){return n.Target_idMustReferToADefinedTarget(u(function(e){return e.target_id===t},e))},C=function(e,t){return n.LogicalType_idMustReferToADefinedLogicalType(u(function(e){return e.logicalType_id===t},e))},D=function(e,t){return n.Operator_idMustReferToADefinedOperator(u(function(e){return e.operator_id===t},e))},_=i(function(e,t){return a(c(function(e){var r=e.operator_id;return t.includes(r)}))(e)}),O=i(function(e,t){return t.$operators=_(e.operators,t.operator_ids),t}),I=i(function(e,t){var r,o,i=(r=e.types,o=t.type_id,d.fromNullable(u(function(e){return e.type_id===o},r)));return n.TargetMustReferToADefinedType(i,t).then(function(e){return t.$type=e,t})}),R=function(e,t){return a(e,(r=t,function(e){return e.then(function(e){return r(),e})}));var r;},w=function(e){e.operators=s(r.Operator,e.operators),e.logicalTypes=s(r.LogicalType,e.logicalTypes),e.argumentTypes=s(r.ArgumentType,e.argumentTypes||[]);var t=a(r.Type,O(e));e.types=s(t,e.types);var n=a(r.Target,I(e));return Promise.all(s(n,e.targets)).then(function(t){return e.targets=t,e})};function L(t){var u=t.data,i=t.columns,c=t.ui,s=t.options,_=c||{};return new Promise(function(e,t){try{r._requireProps(i,"operators,logicalTypes,types,targets");}catch(n){return void t(n)}e();}).then(function(){return w(i)}).then(function(t){var r,i,O=new m,I=o(L.defaults.options,s);var w,M=a(function(){var e=!y.predicateToRemoveIsTheLastComparisonPredicate(r,v,T);v.forEach(r,function(t){t.$canBeRemoved=e&&!y.predicateToRemoveIsRootPredicate(r,t);});},function(){O.emit("changed",i);});function q(e){return n.RootPredicateMustBeACompoundPredicate(e,v).then(function(){r=e;})}function B(r){var o=r.where,u=r.how,i=void 0===u?"after":u,a=r.type;return Promise.resolve().then(function(){return n.AddOnlySupportsAfter(i)}).then(function(){return n.PredicateTypeMustBeValid(a,P.Types)}).then(function(){return I["getDefault".concat(a)](t,I)}).then(function(t){var r=T.is(o);if(r||v.is(o)){if(r){var n=k(o),u=e(f(2,n),2),i=u[0],a=e(u[1],2),c=(a[0],a[1]);i.predicates=p(c+1,t,i.predicates);}else o.predicates.unshift(t);return t}return Promise.reject(new l.CannotAddSomethingElseThanACompoundPredicateOrAComparisonPredicate)})}function b(t){return Promise.resolve().then(function(){return n.RemovePredicateMustDifferFromRootPredicate(r,t)}).then(function(){return n.RemovePredicateCannotBeTheLastComparisonPredicate(r,t,v,T)}).then(function(){if(v.is(t)||T.is(t)){var r=k(t),n=e(f(2,r),2),o=n[0],u=e(n[1],2),i=(u[0],u[1]);return o.predicates.splice(i,1),0===o.predicates.length?b(o):t}return Promise.reject(new l.CannotRemoveSomethingElseThanACompoundPredicateOrAComparisonPredicate)})}function S(e,r){return n.PredicateMustBeACompoundPredicate(e,v).then(function(){return C(t.logicalTypes,r)}).then(function(t){e.logic=t;})}function $(e,r){return n.PredicateMustBeAComparisonPredicate(e,T).then(function(){return A(t.targets,r)}).then(function(t){return e.target=t,E(e,g(e.target.$type.$operators).operator_id)})}function E(e,t){return Promise.resolve().then(function(){return n.Operator_idMustReferToADefinedOperator(e.target.$type.$operators.find(function(e){return e.operator_id===t}))}).then(function(t){e.operator=t,e.argument=null;})}function N(e,t){return Promise.resolve().then(function(){e.argument=t;})}function j(e){return d.fromNullable(t.argumentTypes.find(function(t){return t.argumentType_id===e})).map(function(e){return e.component}).valueOrElse(function(){return I.getDefaultArgumentComponent(t,I,_)})}function U(e){return c[e]}function k(e){return v.reduce(r,function(t,r,n){return e===r?n:t},null)}function F(){return P.toJSON(r)}function J(e,t){O.on(e,t);}function x(e,t){O.once(e,t);}function V(e,t){e?t?O.removeListener(e,t):O.removeAllListeners(e):O.removeAllListeners();}return (u?(w=u,P.fromJSON(w,{getTargetById:function(e){return A(t.targets,e)},getLogicalTypeById:function(e){return C(t.logicalTypes,e)},getOperatorById:function(e){return D(t.operators,e)}})):I.getDefaultData(t,I)).then(R(q,M)).then(function(){return i={on:J,once:x,off:V,setData:R(q,M),add:R(B,M),remove:R(b,M),setPredicateTarget_id:R($,M),setPredicateOperator_id:R(E,M),setPredicateLogicalType_id:R(S,M),setArgumentValue:R(N,M),getArgumentTypeComponentById:j,UITypes:h,getUIComponent:U,toJSON:F,get root(){return r},get columns(){return t},get options(){return I}}})})}return L.defaults={options:{getDefaultData:function(e,t){return t.getDefaultComparisonPredicate(e,t).then(function(r){return t.getDefaultCompoundPredicate(e,t,[r])})},getDefaultCompoundPredicate:function(e,t,r){return (Array.isArray(r)&&0!==r.length?Promise.resolve(r):t.getDefaultComparisonPredicate(e,t).then(function(e){return [e]})).then(function(r){return t.getDefaultLogicalType(r,e,t).then(function(e){return v(e,r)})})},getDefaultComparisonPredicate:function(e,t){var r=g(e.targets);return T(r,g(r.$type.$operators))},getDefaultLogicalType:function(e,t,r){return Promise.resolve(g(t.logicalTypes))},getDefaultArgumentComponent:function(e,t){throw new l.UIFrameworkMustImplementgetDefaultArgumentComponent("UIFrameworkMustImplementgetDefaultArgumentComponent")}}},L};
	},{"ramda/src/merge":"mgRa","ramda/src/find":"uq3h","ramda/src/curry":"UkKV","ramda/src/pipe":"RMMw","ramda/src/filter":"h7VV","ramda/src/map":"Bsaj","ramda/src/takeLast":"DeV3","ramda/src/insert":"cEbX","option":"wygZ","events":"FRpO"}],"Focm":[function(require,module,exports) {
	var r=require("./errors"),e=require("./UITypes"),s=require("./rules"),a=require("./invariants")({errors:r,rules:s}),i=require("./dataclasses")({invariants:a,errors:r}),t=require("./PredicateCore")({dataclasses:i,invariants:a,errors:r,rules:s,UITypes:e});module.exports={PredicateCore:t,errors:r,invariants:a,UITypes:e,dataclasses:i};
	},{"./errors":"p8GN","./UITypes":"lIRz","./rules":"vQMb","./invariants":"DfgV","./dataclasses":"wTLu","./PredicateCore":"Obe2"}]},{},["Focm"]);

	}(uiPredicateCore));

	/** Detect free variable `global` from Node.js. */

	var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	var _freeGlobal = freeGlobal$1;

	var freeGlobal = _freeGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root$2 = freeGlobal || freeSelf || Function('return this')();

	var _root = root$2;

	var root$1 = _root;

	/** Built-in value references. */
	var Symbol$3 = root$1.Symbol;

	var _Symbol = Symbol$3;

	var Symbol$2 = _Symbol;

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$8.toString;

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag$1(value) {
	  var isOwn = hasOwnProperty$6.call(value, symToStringTag$1),
	      tag = value[symToStringTag$1];

	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString$1.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}

	var _getRawTag = getRawTag$1;

	/** Used for built-in method references. */

	var objectProto$7 = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto$7.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString$1(value) {
	  return nativeObjectToString.call(value);
	}

	var _objectToString = objectToString$1;

	var Symbol$1 = _Symbol,
	    getRawTag = _getRawTag,
	    objectToString = _objectToString;

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag$3(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	var _baseGetTag = baseGetTag$3;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */

	function isObject$3(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject$3;

	var baseGetTag$2 = _baseGetTag,
	    isObject$2 = isObject_1;

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag$1 = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$2(value) {
	  if (!isObject$2(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag$2(value);
	  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	var isFunction_1 = isFunction$2;

	var root = _root;

	/** Used to detect overreaching core-js shims. */
	var coreJsData$1 = root['__core-js_shared__'];

	var _coreJsData = coreJsData$1;

	var coreJsData = _coreJsData;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked$1(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	var _isMasked = isMasked$1;

	/** Used for built-in method references. */

	var funcProto$1 = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource$1(func) {
	  if (func != null) {
	    try {
	      return funcToString$1.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	var _toSource = toSource$1;

	var isFunction$1 = isFunction_1,
	    isMasked = _isMasked,
	    isObject$1 = isObject_1,
	    toSource = _toSource;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto$6 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative$1(value) {
	  if (!isObject$1(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	var _baseIsNative = baseIsNative$1;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */

	function getValue$1(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue$1;

	var baseIsNative = _baseIsNative,
	    getValue = _getValue;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative$1(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	var _getNative = getNative$1;

	var getNative = _getNative;

	var defineProperty$2 = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	var _defineProperty$1 = defineProperty$2;

	var defineProperty$1 = _defineProperty$1;

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue$2(object, key, value) {
	  if (key == '__proto__' && defineProperty$1) {
	    defineProperty$1(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	var _baseAssignValue = baseAssignValue$2;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */

	function eq$2(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	var eq_1 = eq$2;

	var baseAssignValue$1 = _baseAssignValue,
	    eq$1 = eq_1;

	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue$2(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty$4.call(object, key) && eq$1(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue$1(object, key, value);
	  }
	}

	var _assignValue = assignValue$2;

	var assignValue$1 = _assignValue,
	    baseAssignValue = _baseAssignValue;

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject$1(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue$1(object, key, newValue);
	    }
	  }
	  return object;
	}

	var _copyObject = copyObject$1;

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */

	function identity$2(value) {
	  return value;
	}

	var identity_1 = identity$2;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */

	function apply$1(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	var _apply = apply$1;

	var apply = _apply;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest$1(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}

	var _overRest = overRest$1;

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */

	function constant$1(value) {
	  return function() {
	    return value;
	  };
	}

	var constant_1 = constant$1;

	var constant = constant_1,
	    defineProperty = _defineProperty$1,
	    identity$1 = identity_1;

	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString$1 = !defineProperty ? identity$1 : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};

	var _baseSetToString = baseSetToString$1;

	/** Used to detect hot functions by number of calls within a span of milliseconds. */

	var HOT_COUNT = 800,
	    HOT_SPAN = 16;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;

	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut$1(func) {
	  var count = 0,
	      lastCalled = 0;

	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);

	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}

	var _shortOut = shortOut$1;

	var baseSetToString = _baseSetToString,
	    shortOut = _shortOut;

	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString$1 = shortOut(baseSetToString);

	var _setToString = setToString$1;

	var identity = identity_1,
	    overRest = _overRest,
	    setToString = _setToString;

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest$1(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}

	var _baseRest = baseRest$1;

	/** Used as references for various `Number` constants. */

	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength$2(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	var isLength_1 = isLength$2;

	var isFunction = isFunction_1,
	    isLength$1 = isLength_1;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike$3(value) {
	  return value != null && isLength$1(value.length) && !isFunction(value);
	}

	var isArrayLike_1 = isArrayLike$3;

	/** Used as references for various `Number` constants. */

	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex$2(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	var _isIndex = isIndex$2;

	var eq = eq_1,
	    isArrayLike$2 = isArrayLike_1,
	    isIndex$1 = _isIndex,
	    isObject = isObject_1;

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall$1(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike$2(object) && isIndex$1(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}

	var _isIterateeCall = isIterateeCall$1;

	var baseRest = _baseRest,
	    isIterateeCall = _isIterateeCall;

	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner$1(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;

	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;

	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}

	var _createAssigner = createAssigner$1;

	/** Used for built-in method references. */

	var objectProto$4 = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype$2(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

	  return value === proto;
	}

	var _isPrototype = isPrototype$2;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */

	function baseTimes$1(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	var _baseTimes = baseTimes$1;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */

	function isObjectLike$3(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1 = isObjectLike$3;

	var baseGetTag$1 = _baseGetTag,
	    isObjectLike$2 = isObjectLike_1;

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments$1(value) {
	  return isObjectLike$2(value) && baseGetTag$1(value) == argsTag$1;
	}

	var _baseIsArguments = baseIsArguments$1;

	var baseIsArguments = _baseIsArguments,
	    isObjectLike$1 = isObjectLike_1;

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments$1 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike$1(value) && hasOwnProperty$3.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	var isArguments_1 = isArguments$1;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */

	var isArray$1 = Array.isArray;

	var isArray_1 = isArray$1;

	var isBuffer$1 = {exports: {}};

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */

	function stubFalse() {
	  return false;
	}

	var stubFalse_1 = stubFalse;

	(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer;
	}(isBuffer$1, isBuffer$1.exports));

	var baseGetTag = _baseGetTag,
	    isLength = isLength_1,
	    isObjectLike = isObjectLike_1;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray$1(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray$1;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */

	function baseUnary$1(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary$1;

	var _nodeUtil = {exports: {}};

	(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
	}(_nodeUtil, _nodeUtil.exports));

	var baseIsTypedArray = _baseIsTypedArray,
	    baseUnary = _baseUnary,
	    nodeUtil = _nodeUtil.exports;

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	var isTypedArray_1 = isTypedArray$1;

	var baseTimes = _baseTimes,
	    isArguments = isArguments_1,
	    isArray = isArray_1,
	    isBuffer = isBuffer$1.exports,
	    isIndex = _isIndex,
	    isTypedArray = isTypedArray_1;

	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys$1(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$2.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys$1;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */

	function overArg$1(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg$1;

	var overArg = _overArg;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys$1 = overArg(Object.keys, Object);

	var _nativeKeys = nativeKeys$1;

	var isPrototype$1 = _isPrototype,
	    nativeKeys = _nativeKeys;

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys$1(object) {
	  if (!isPrototype$1(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$1.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeys = baseKeys$1;

	var arrayLikeKeys = _arrayLikeKeys,
	    baseKeys = _baseKeys,
	    isArrayLike$1 = isArrayLike_1;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$1(object) {
	  return isArrayLike$1(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	var keys_1 = keys$1;

	var assignValue = _assignValue,
	    copyObject = _copyObject,
	    createAssigner = _createAssigner,
	    isArrayLike = isArrayLike_1,
	    isPrototype = _isPrototype,
	    keys = keys_1;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});

	var assign_1 = assign;

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function Target(_ref) {
	  var columns = _ref.columns,
	      predicate = _ref.predicate,
	      _onChange = _ref.onChange;
	  return /*#__PURE__*/React__default['default'].createElement("select", {
	    className: "ui-predicate__targets",
	    value: predicate.target.target_id,
	    onChange: function onChange(e) {
	      return _onChange(e.target.value);
	    }
	  }, columns.targets.map(function (target) {
	    return /*#__PURE__*/React__default['default'].createElement("option", {
	      key: target.label,
	      value: target.target_id
	    }, target.label);
	  }));
	}
	Target.propTypes = {
	  columns: PropTypes__default['default'].object,
	  predicate: PropTypes__default['default'].object,
	  onChange: PropTypes__default['default'].func
	};

	function LogicalTypes(_ref) {
	  var predicate = _ref.predicate,
	      columns = _ref.columns,
	      _onChange = _ref.onChange;
	  return /*#__PURE__*/React__default['default'].createElement("select", {
	    className: "ui-predicate__logic",
	    value: predicate.logic.logicalType_id,
	    onChange: function onChange(e) {
	      return _onChange(e.target.value);
	    }
	  }, columns.logicalTypes.map(function (logicalType) {
	    return /*#__PURE__*/React__default['default'].createElement("option", {
	      key: logicalType.label,
	      value: logicalType.logicalType_id
	    }, logicalType.label);
	  }));
	}
	LogicalTypes.propTypes = {
	  predicate: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object,
	  onChange: PropTypes__default['default'].func
	};

	function Operators(_ref) {
	  var predicate = _ref.predicate,
	      _onChange = _ref.onChange;
	  return /*#__PURE__*/React__default['default'].createElement("select", {
	    className: "ui-predicate__operators",
	    value: predicate.operator.operator_id,
	    onChange: function onChange(e) {
	      return _onChange(e.target.value);
	    }
	  }, predicate.target.$type.$operators.map(function (operator) {
	    return /*#__PURE__*/React__default['default'].createElement("option", {
	      key: operator.label,
	      value: operator.operator_id
	    }, operator.label);
	  }));
	}
	Operators.propTypes = {
	  predicate: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object,
	  onChange: PropTypes__default['default'].func
	};

	function PredicateAdd(_ref) {
	  var isInAddCompoundMode = _ref.isInAddCompoundMode,
	      onClick = _ref.onClick;
	  return /*#__PURE__*/React__default['default'].createElement("button", {
	    type: "button",
	    onClick: onClick
	  }, isInAddCompoundMode ? '…' : '+');
	}
	PredicateAdd.propTypes = {
	  isInAddCompoundMode: PropTypes__default['default'].bool,
	  onClick: PropTypes__default['default'].func
	};

	function PredicateRemove(_ref) {
	  var disabled = _ref.disabled,
	      onClick = _ref.onClick;
	  return /*#__PURE__*/React__default['default'].createElement("button", {
	    type: "button",
	    disabled: disabled,
	    onClick: onClick
	  }, "-");
	}
	PredicateRemove.propTypes = {
	  disabled: PropTypes__default['default'].bool,
	  onClick: PropTypes__default['default'].func
	};

	function ArgumentDefault(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange;
	  return /*#__PURE__*/React__default['default'].createElement("input", {
	    type: "text",
	    value: value,
	    onChange: function onChange(e) {
	      return _onChange(e.target.value);
	    }
	  });
	}
	ArgumentDefault.propTypes = {
	  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
	  onChange: PropTypes__default['default'].func
	};

	var _UITypes$TARGETS$UITy;
	var DEFAULT_COMPONENTS = (_UITypes$TARGETS$UITy = {}, _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.TARGETS, Target), _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.LOGICAL_TYPES, LogicalTypes), _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.OPERATORS, Operators), _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.PREDICATE_ADD, PredicateAdd), _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.PREDICATE_REMOVE, PredicateRemove), _defineProperty(_UITypes$TARGETS$UITy, uiPredicateCore.exports.UITypes.ARGUMENT_DEFAULT, ArgumentDefault), _UITypes$TARGETS$UITy);

	/* eslint no-unused-vars: "off"*/
	var defaults = {
	  options: {
	    /**
	     * UIPredicate React Adapter own default argument component
	     * @param {Object} [columns=PredicateCore.defaults.columns] columns
	     * @param {Object} [options=PredicateCore.defaults.options] options
	     * @param {Object} [ui=PredicateCore.defaults.ui] ui
	     * @return {React.component} the default React Component to use as argument specifier
	     * @see core.defaults.getDefaultArgumentComponent
	     * @memberof React.defaults
	     */
	    getDefaultArgumentComponent: function getDefaultArgumentComponent(columns, options, ui) {
	      /*
	        "ui" arg. results from DEFAULT_COMPONENTS
	        and :ui attribute passed to <ui-predicate>
	        all merged in UIPredicateCoreReact()
	        and passed to PredicateCore
	      */
	      return ui[uiPredicateCore.exports.UITypes.ARGUMENT_DEFAULT];
	    }
	  }
	};
	/**
	 * UIPredicateCore adapter for ReactJS
	 * @param {?dataclasses.CompoundPredicate} [data=PredicateCore.defaults.options.getDefaultData] data
	 * @param {Object} [columns=PredicateCore.defaults.columns] columns
	 * @param {Object} [ui=PredicateCore.defaults.ui] ui
	 * @param {Object} [options=PredicateCore.defaults.options] options
	 * @return {Promise<core.PredicateCoreAPI>} resolved promise yield a PredicateCoreAPI
	 * @memberof React
	 */

	function UIPredicateCoreReact() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      data = _ref.data,
	      columns = _ref.columns,
	      ui = _ref.ui,
	      options = _ref.options;

	  return uiPredicateCore.exports.PredicateCore({
	    data: data,
	    columns: columns,
	    ui: assign_1({}, DEFAULT_COMPONENTS, ui),
	    options: assign_1({}, defaults.options, options)
	  });
	}

	UIPredicateCoreReact.defaults = defaults;

	function styleInject(css, ref) {
	  if ( ref === void 0 ) ref = {};
	  var insertAt = ref.insertAt;

	  if (!css || typeof document === 'undefined') { return; }

	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';

	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }

	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z = ".ui-predicate__main {\n  display: flex;\n}\n.ui-predicate__row {\n  flex-direction: row;\n}\n.ui-predicate__col {\n  display: inline-block;\n  margin: 0 2px;\n}\n.ui-predicate__options {\n  display: flex;\n}\n";
	styleInject(css_248z);

	function UIPredicate(_ref) {
	  var _ref$data = _ref.data,
	      data = _ref$data === void 0 ? {} : _ref$data,
	      columns = _ref.columns,
	      ui = _ref.ui,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? '' : _ref$className,
	      _ref$onChange = _ref.onChange,
	      _onChange = _ref$onChange === void 0 ? function () {
	    return undefined;
	  } : _ref$onChange;

	  var _useState = React.useState(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      ctrl = _useState2[0],
	      setCtrl = _useState2[1]; // even if we don't do anything with it, we need to store the ast
	  // to force the component to re-render when it changes

	  /* eslint-disable no-unused-vars */


	  var _useState3 = React.useState({}),
	      _useState4 = _slicedToArray(_useState3, 2);
	      _useState4[0];
	      var setAST = _useState4[1];

	  React.useEffect(function () {
	    UIPredicateCoreReact({
	      data: data,
	      columns: columns,
	      ui: ui
	    }).then(setCtrl, function (err) {
	      // wrap ui-predicate-core error in InitialisationFailed error
	      return Promise.reject(Object.assign(new errors.InitialisationFailed(), {
	        cause: err
	      }));
	    });
	  }, []);
	  if (!ctrl) return null;
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: className
	  }, /*#__PURE__*/React__default['default'].createElement(UIPredicateView, {
	    ctrl: ctrl,
	    columns: columns,
	    onChange: function onChange(newAST) {
	      setAST(newAST);

	      _onChange(newAST);
	    }
	  }));
	}
	UIPredicate.propTypes = {
	  data: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object,
	  ui: PropTypes__default['default'].object,
	  className: PropTypes__default['default'].string,
	  onChange: PropTypes__default['default'].func
	};

	function UIPredicateView(_ref2) {
	  var ctrl = _ref2.ctrl,
	      columns = _ref2.columns,
	      onChange = _ref2.onChange;

	  var _useState5 = React.useState(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isInAddCompoundMode = _useState6[0],
	      setIsInAddCompoundMode = _useState6[1];

	  React.useEffect(function () {
	    onChange(ctrl.toJSON());
	    ctrl.on('changed', function () {
	      onChange(ctrl.toJSON());
	    });
	  }, []);
	  React.useEffect(function () {
	    function onAltKey(_ref3) {
	      var newIsInAddCompoundMode = _ref3.newIsInAddCompoundMode;
	      return function (e) {
	        if (e.keyCode === 18) setIsInAddCompoundMode(newIsInAddCompoundMode);
	      };
	    }

	    var onAltPressed = onAltKey({
	      newIsInAddCompoundMode: true
	    });
	    var onAltReleased = onAltKey({
	      newIsInAddCompoundMode: false
	    });
	    window.addEventListener('keyup', onAltReleased);
	    window.addEventListener('keydown', onAltPressed);
	    return function () {
	      window.removeEventListener('keyup', onAltReleased);
	      window.removeEventListener('keydown', onAltPressed);
	    };
	  }, []);
	  return /*#__PURE__*/React__default['default'].createElement(UIPredicateContext.Provider, {
	    value: {
	      UITypes: uiPredicateCore.exports.UITypes,
	      isInAddCompoundMode: isInAddCompoundMode,
	      add: function add(predicate) {
	        return ctrl.add({
	          where: predicate,
	          how: 'after',
	          type: isInAddCompoundMode ? 'CompoundPredicate' : 'ComparisonPredicate'
	        });
	      },
	      remove: function remove(predicate) {
	        return ctrl.remove(predicate);
	      },
	      setPredicateLogicalType_id: function setPredicateLogicalType_id(predicate, logicalType_id) {
	        return ctrl.setPredicateLogicalType_id(predicate, logicalType_id);
	      },
	      setPredicateTarget_id: function setPredicateTarget_id(predicate, target_id) {
	        return ctrl.setPredicateTarget_id(predicate, target_id);
	      },
	      setPredicateOperator_id: function setPredicateOperator_id(predicate, operator_id) {
	        return ctrl.setPredicateOperator_id(predicate, operator_id);
	      },
	      getArgumentTypeComponentById: function getArgumentTypeComponentById(argumentType_id) {
	        return ctrl.getArgumentTypeComponentById(argumentType_id);
	      },
	      setArgumentValue: function setArgumentValue(predicate, value) {
	        return ctrl.setArgumentValue(predicate, value);
	      },
	      getUIComponent: function getUIComponent(name) {
	        return ctrl.getUIComponent(name);
	      }
	    }
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: "ui-predicate__main"
	  }, ctrl && /*#__PURE__*/React__default['default'].createElement(UIPredicateCompound, {
	    predicate: ctrl.root,
	    columns: columns
	  })));
	}

	UIPredicateView.propTypes = {
	  ctrl: PropTypes__default['default'].object,
	  columns: PropTypes__default['default'].object,
	  onChange: PropTypes__default['default'].func
	};

	var components = /*#__PURE__*/Object.freeze({
		__proto__: null,
		UIPredicateOptions: UIPredicateOptions,
		UIPredicateComparison: UIPredicateComparison,
		UIPredicateComparisonArgument: UIPredicateComparisonArgument,
		UIPredicateCompound: UIPredicateCompound,
		UIPredicate: UIPredicate
	});

	var require$$1 = /*@__PURE__*/getAugmentedNamespace(components);

	var name = "ui-predicate-react";
	var version = "1.0.4";
	var description = "Finally a predicate UI component for ReactJS";
	var main = "build/index.cjs.js";
	var module = "build/index.esm.js";
	var browser = "build/index.js";
	var style = "build/index.css";
	var files = [
		"build"
	];
	var author = "Francois-Guillaume Ribreau <npm@fgribreau.com> (http://fgribreau.com/)";
	var contributors = [
		"Romain Baumier <baumier.romain@gmail.com> (https://rbaumier.com/)"
	];
	var license = "MIT";
	var scripts = {
		test: "true",
		lint: "eslint --fix getting-started src",
		build: "rollup -c",
		"test:coverage": "true",
		"docs:jsdoc:build": "true",
		"docs:getting-started:start": "parcel serve ./getting-started/index.html",
		"docs:storybook:watch": "start-storybook -p 9001",
		"docs:storybook:build": "build-storybook --output-dir ../../docs/packages/$npm_package_name/$npm_package_version/examples"
	};
	var dependencies = {
		"prop-types": "^15.7.2",
		"ui-predicate-core": "^0.6.4"
	};
	var devDependencies = {
		"@babel/cli": "^7.14.5",
		"@babel/core": "^7.14.6",
		"@babel/plugin-transform-runtime": "^7.14.5",
		"@babel/preset-env": "^7.14.7",
		"@babel/preset-react": "^7.14.5",
		"@rollup/plugin-babel": "^5.3.0",
		"@rollup/plugin-commonjs": "^19.0.0",
		"@rollup/plugin-json": "^4.1.0",
		"@rollup/plugin-node-resolve": "^13.0.0",
		"@storybook/addon-actions": "^6.2.9",
		"@storybook/addon-essentials": "^6.2.9",
		"@storybook/addon-links": "^6.2.9",
		"@storybook/addon-notes": "^5.3.21",
		"@storybook/react": "^6.2.9",
		"babel-loader": "^8.2.2",
		eslint: "^7.29.0",
		"eslint-plugin-react": "^7.24.0",
		jsdoc: "^3.5.5",
		"parcel-bundler": "^1.12.5",
		postcss: "^8.3.5",
		react: "^17.0.2",
		"react-dom": "^17.0.2",
		rollup: "^2.53.1",
		"rollup-plugin-filesize": "^9.1.1",
		"rollup-plugin-postcss": "^4.0.0"
	};
	var peerDependencies = {
		react: "^16.8.0 || ^17",
		"react-dom": "^16.8.0 || ^17"
	};
	var targets = {
		browser: {
			engines: {
				browsers: "> 0.25%"
			}
		}
	};
	var require$$2 = {
		name: name,
		version: version,
		description: description,
		main: main,
		module: module,
		browser: browser,
		style: style,
		files: files,
		author: author,
		contributors: contributors,
		license: license,
		scripts: scripts,
		dependencies: dependencies,
		devDependencies: devDependencies,
		peerDependencies: peerDependencies,
		targets: targets
	};

	(function (module) {
	var errors$1 = errors;

	var _require = require$$1,
	    UIPredicateOptions = _require.UIPredicateOptions,
	    UIPredicateComparison = _require.UIPredicateComparison,
	    UIPredicateComparisonArgument = _require.UIPredicateComparisonArgument,
	    UIPredicateCompound = _require.UIPredicateCompound,
	    UIPredicate = _require.UIPredicate;
	/* istanbul ignore if */


	if (typeof window !== "undefined") window.UIPredicate = UIPredicate;
	module.exports = {
	  version: require$$2.version,
	  UIPredicateOptions: UIPredicateOptions,
	  UIPredicateComparison: UIPredicateComparison,
	  UIPredicateComparisonArgument: UIPredicateComparisonArgument,
	  UIPredicateCompound: UIPredicateCompound,
	  UIPredicate: UIPredicate,
	  errors: errors$1
	};
	module.exports["default"] = module.exports;
	}(src$1));

	var src = src$1.exports;

	return src;

})));
